<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="flex flex-row gap-6 w-full h-full" v-else>
        <div class="flex flex-1 flex-col overflow-x-auto">
            <div class="alert bg-blue-custom-8 text-blue-custom-9">
                <span class="mx-auto"> {{ __('Reserve goods list') }}</span>
            </div>
            <div class="tabs block mt-4">
                <button class="tab tab-lifted" :class="{ 'tab-active': activeTab === 'in_stock' }"
                    @click="setActiveTab('in_stock')">{{ __('Available ones') }}</button>
                <button class="tab tab-lifted" :class="{ 'tab-active': activeTab === 'out_stock' }"
                    @click="setActiveTab('out_stock')">{{ __('out of stock') }}</button>
                <div class="h-full">
                    <NotFound v-if="!products.filter(item => item.stock_status === activeTab).length" class="mt-16" />
                    <div class="card mt-4 bg-white reserve" v-else>
                        <div class="card-body p-0">
                            <ProductItem :products="products" :loading="loading" @changeQuantity="changeQuantity" @getProduct="showProduct" :meta="meta"
                                @setProduct="setProduct" :activeTab="activeTab" />
                        </div>
                    </div>
                    <div class="flex justify-end mt-4"
                        v-if="activeTab === 'in_stock' && products.filter(item => item.stock_status === activeTab).length">
                        <router-link :to="{ name: 'product' }" class="btn btn-info btn-sm">{{ __('Products page') }}
                        </router-link>
                        <button class="btn btn-success btn-sm mr-3" @click="updateCart">{{ __('Add to acrt')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <LeftSidebar :large="true" />
    </div>
    <ProductModal :product="product" :introductionBrand="introductionBrand"/>
    <ReserveModal :reserve="reserve" @change="changeQuantity" />
    <ProductQuantityModal />
    <Teleport to="#app">
        <input type="checkbox" id="delete-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg">{{ __('Delete') }}</h3>
                <p class="pt-4">{{ __('Are you sure you want to delete this product?') }}</p>
                <div class="modal-action">
                    <label class="btn btn-error btn-sm px-4" @click="removeCart(product, true)" for="delete-modal">{{
                            __('Yes')
                    }}</label>
                    <label class="btn btn-primary btn-sm" for="delete-modal">{{ __('No') }}</label>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script setup>
import useProducts from "../../../composables/shop/product";
import { computed, onMounted, reactive, ref } from 'vue';

import LeftSidebar from "../layout/LeftSidebar.vue";
import ProductItem from "./ProductItem.vue";
import ProductModal from "../modal/ProductModal.vue";
import ReserveModal from "../modal/ReserveModal.vue";
import ProductQuantityModal from "../modal/ProductQuantityModal.vue";

const { errors, loading, product, products, getReserve, reserve, getProduct, changeQuantity, removeCart,meta,isReserve, introductionBrand,updateCart } = useProducts();
const activeTab = ref('in_stock');
const showProduct = (slug) => getProduct(slug);
const setActiveTab = (tab) => activeTab.value = tab;
const setProduct = (id) => product.id = id;
const getData = () => getReserve();
isReserve.value = true;
onMounted(() => {
  getData();
  window.onhashchange = () => {
    const productModal = document.getElementById('product-modal');
    if (productModal.checked && !window.location.hash) productModal.checked = false;
  }
});
</script>
  